import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowTableContainer: Components<Theme>['MuiTableContainer'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      border: `1px solid ${theme.palette.surface.secondary}`,
      borderRadius: '8px',
      '&::-webkit-scrollbar:horizontal': {
        borderBottomLeftRadius: '100px',
        borderBottomRightRadius: '100px',
        // 4px scrollbar height + 2x 24px margin
        height: '52px',
        borderTop: `1px solid ${theme.palette.surface.secondary}`,
      },
      '&::-webkit-scrollbar-thumb:horizontal, &::-webkit-scrollbar-track:horizontal': {
        borderWidth: '24px',
      },
      // connect with pagination
      '&:has( + .MuiTablePagination-root)': {
        borderBottomLeftRadius: '0',
        borderBottomRightRadius: '0',
      },
      '& + .MuiTablePagination-root': {
        borderTopLeftRadius: '0',
        borderTopRightRadius: '0',
        borderTop: '0',
      },
    }),
  },
};
